import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ContactHero from './components/ContactHero';
import WhatsAppBenefits from './components/WhatsAppBenefits';
import ContactMethods from './components/ContactMethods';
import ExpertTeam from './components/ExpertTeam';
import ContactFAQ from './components/ContactFAQ';
import QuickContactOptions from './components/QuickContactOptions';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Icon from '../../components/AppIcon';


const VIPContactSuiteWhatsAppHub = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hello! I'm interested in Nitin's premium gaming services. Can you help me get started?");
    window.open(`https://wa.me/917704070169?text=${message}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>VIP Contact Suite - WhatsApp Hub | Nitin Online Hub | Nitin Online Book</title>
        <meta name="description" content="Connect with India's premier gaming experts at Nitin Online Hub and Nitin Online Book through WhatsApp. Get instant support for Nitin online book login, sign up, app download, and personalized recommendations. 24/7 VIP customer service available." />
        <meta name="keywords" content="Nitin Online Hub WhatsApp, Nitin Online Book support, WhatsApp support, gaming experts, VIP customer service, instant chat, gaming consultation, Nitin support, Nitin online book help, Nitin online book contact" />
        <meta property="og:title" content="VIP Contact Suite - WhatsApp Hub | Nitin Online Hub | Nitin Online Book" />
        <meta property="og:description" content="Connect with India's premier gaming experts at Nitin Online Hub and Nitin Online Book through WhatsApp. Get instant support for Nitin online book login, sign up, app download, and personalized recommendations." />
        <meta property="og:image" content="https://nitinonlinehub.in/assets/images/logo.png" />
        <meta property="og:url" content="https://nitinonlinehub.in/vip-contact-suite-whats-app-hub" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Nitin Online Hub" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="VIP Contact Suite - WhatsApp Hub | Nitin Online Hub | Nitin Online Book" />
        <meta name="twitter:description" content="Connect with India's premier gaming experts at Nitin Online Hub and Nitin Online Book through WhatsApp. Get instant support for Nitin online book login, sign up, app download, and personalized recommendations." />
        <meta name="twitter:image" content="https://nitinonlinehub.in/assets/images/logo.png" />
        <link rel="canonical" href="https://nitinonlinehub.in/vip-contact-suite-whats-app-hub" />

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://nitinonlinehub.in/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Contact",
                  "item": "https://nitinonlinehub.in/vip-contact-suite-whats-app-hub"
                }
              ]
            }
          `}
        </script>
        <meta property="og:title" content="VIP Contact Suite - WhatsApp Hub | Nitin Online Hub" />
        <meta property="og:description" content="Experience premium gaming support through WhatsApp. Connect with certified experts for personalized gaming advice and exclusive offers." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://nitinonlinehub.in/vip-contact-suite-whats-app-hub" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        {/* Hero Section */}
        <ContactHero onWhatsAppClick={handleWhatsAppClick} />
        
        {/* WhatsApp Benefits */}
        <WhatsAppBenefits />
        
        {/* Contact Methods */}
        <ContactMethods onWhatsAppClick={handleWhatsAppClick} />
        
        {/* Expert Team */}
        <ExpertTeam />
        
        {/* Quick Contact Options */}
        <QuickContactOptions onWhatsAppClick={handleWhatsAppClick} />
        
        {/* FAQ Section */}
        <ContactFAQ />
        
        {/* Floating WhatsApp Widget */}
        <FloatingWhatsApp onWhatsAppClick={handleWhatsAppClick} />
        
        {/* Footer CTA Section */}
        <section className="py-16 bg-gradient-to-r from-primary/10 via-accent/5 to-primary/10">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-surface rounded-card shadow-royal p-8 lg:p-12 border border-golden">
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-gradient-royal rounded-full flex items-center justify-center shadow-royal animate-float">
                  <Icon name="Crown" size={40} color="white" strokeWidth={2} />
                </div>
              </div>
              
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-gradient-royal mb-6">
                Ready to Experience Royal Treatment?
              </h2>
              
              <p className="text-lg text-text-secondary mb-8 max-w-2xl mx-auto leading-relaxed">
                Join thousands of satisfied players who trust Nitin's premium WhatsApp support for their gaming journey. Experience the difference of personalized expert guidance.
              </p>
              
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
                <button
                  onClick={handleWhatsAppClick}
                  className="bg-gradient-royal text-white px-8 py-4 rounded-button font-semibold text-lg hover:shadow-glow transition-royal animate-pulse-golden hover:animate-none inline-flex items-center space-x-3"
                >
                  <Icon name="MessageCircle" size={24} color="white" strokeWidth={2} />
                  <span>Start Your VIP Experience</span>
                </button>
                
                <div className="flex items-center space-x-2 text-text-secondary">
                  <div className="w-3 h-3 bg-success rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium">3 Gaming Experts Online Now</span>
                </div>
              </div>
              
              {/* Trust Indicators */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-border">
                <div className="flex items-center justify-center space-x-2">
                  <Icon name="Shield" size={20} color="var(--color-success)" />
                  <span className="text-sm text-text-secondary">100% Secure & Private</span>
                </div>
                <div className="flex items-center justify-center space-x-2">
                  <Icon name="Clock" size={20} color="var(--color-primary)" />
                  <span className="text-sm text-text-secondary">24/7 Expert Support</span>
                </div>
                <div className="flex items-center justify-center space-x-2">
                  <Icon name="Star" size={20} color="var(--color-warning)" />
                  <span className="text-sm text-text-secondary">4.9/5 Customer Rating</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VIPContactSuiteWhatsAppHub;